<template>
    <form @submit.prevent="submit">
        <md-input-container :class="{'md-input-invalid': currentPasswordError}">
        <label for="current-password-input">Current Password</label>
        <md-input
            id="current-password-input"
            :type="showCurrentPassword ? 'text' : 'password'"
            v-model="currentPassword"
            required
            @input="validateAll"
            @paste="validateAll"
        ></md-input>
        <span class="toggle-password" @click="toggleShowPassword('current')">
            <md-icon>{{ showCurrentPassword ? 'visibility' : 'visibility_off' }}</md-icon>
        </span>
        <span class="md-error" v-if="currentPasswordError">{{ errorMessage }}</span>
        </md-input-container>

        <md-input-container :class="{'md-input-invalid': newPasswordError}">
        <label for="new-password-input">New Password</label>
        <md-input
            id="new-password-input"
            :type="showNewPassword ? 'text' : 'password'"
            v-model="newPassword"
            required
            @input="validateAll"
            @paste="validateAll"
        ></md-input>
        <span class="toggle-password" @click="toggleShowPassword('new')">
            <md-icon>{{ showNewPassword ? 'visibility' : 'visibility_off' }}</md-icon>
        </span>
        <span class="md-error" v-if="newPasswordError">
            {{ sameAsCurrentPassword ? 'New password cannot be the same as current password' : errorMessage }}
        </span>
        </md-input-container>

        <!-- Confirm Password -->
        <md-input-container :class="{'md-input-invalid': confirmPasswordError}">
        <label for="confirm-password-input">Re-Type Password</label>
        <md-input
            id="confirm-password-input"
            :type="showConfirmPassword ? 'text' : 'password'"
            v-model="confirmPassword"
            required
            @input="validateAll"
            @paste="validateAll"
        ></md-input>
        <span class="toggle-password" @click="toggleShowPassword('confirm')">
            <md-icon>{{ showConfirmPassword ? 'visibility' : 'visibility_off' }}</md-icon>
        </span>
        <span class="md-error" v-if="confirmPasswordError">Passwords do not match</span>
        </md-input-container>

        <!-- Submit -->
        <md-button class="md-raised" :disabled="!isComplete || loading" @click="submit">
        {{ loading ? 'Submitting...' : 'Submit' }}
        </md-button>
    </form>
</template>
  
<script>
import firebase from 'firebase/app';
import { mapGetters } from 'vuex';
  
export default {
    name: 'change-password',
    data() {
        return {
            currentPassword: '',
            newPassword: '',
            confirmPassword: '',
            errorMessage: '',
            loading: false,
            showCurrentPassword: false,
            showNewPassword: false,
            showConfirmPassword: false
        };
    },
    computed: {
        ...mapGetters(['user']),
        currentPasswordError() {
            return this.errorMessage && this.hasError === 'auth/wrong-password';
        },
        newPasswordError() {
            return this.sameAsCurrentPassword || this.hasError === 'auth/weak-password';
        },
        confirmPasswordError() {
            return this.newPassword && this.confirmPassword && this.newPassword !== this.confirmPassword;
        },
        sameAsCurrentPassword() {
            return this.currentPassword && this.newPassword && this.currentPassword === this.newPassword;
        },
        isComplete() {
            return (
                this.currentPassword &&
                this.newPassword &&
                this.confirmPassword &&
                !this.newPasswordError &&
                !this.confirmPasswordError
            );
        }
    },
    methods: {
        toggleShowPassword(field) {
            if (field === 'current') this.showCurrentPassword = !this.showCurrentPassword;
            if (field === 'new') this.showNewPassword = !this.showNewPassword;
            if (field === 'confirm') this.showConfirmPassword = !this.showConfirmPassword;
        },
        validateAll() {
            // Trigger computed properties
            this.$forceUpdate();
        },
        async submit() {
            this.loading = true;
            this.errorMessage = '';
            const currentUser = firebase.auth().currentUser;
            const credential = firebase.auth.EmailAuthProvider.credential(this.user.email, this.currentPassword);

            try {
                await currentUser.reauthenticateWithCredential(credential);
                await currentUser.updatePassword(this.newPassword);
                this.currentPassword = '';
                this.newPassword = '';
                this.confirmPassword = '';
                this.$toast.success('Your password has been successfully changed.');
            } catch (error) {
                this.errorMessage = error.message;
                this.hasError = error.code;
                this.$toast.error(error.message);
            }

            this.loading = false;
        }
    }
};
</script>

<style scoped>
form {
    width: 100%;
    text-align: center;
}
.toggle-password {
    cursor: pointer;
    margin-left: 10px;
    color: #007bff;
    font-size: 1.2em;
    display: inline-flex;
    align-items: center;
}
.md-button[disabled].md-theme-show-mode {
    background-color: #555555;
    color: white;
}
.md-input-container .md-theme-show-mode.md-icon:not(.md-icon-delete) {
    color: white;
}
</style>


// WEBPACK FOOTER //
// change-password.vue?0cdf5070